export function formatarData(data) {
  if (!data) return "";
  const date = new Date(data);
  if (isNaN(date.getTime())) return "";
  const dia = String(date.getUTCDate()).padStart(2, "0");
  const mes = String(date.getUTCMonth() + 1).padStart(2, "0");
  const ano = date.getUTCFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function getDataHoraLocal () {
  const agora = new Date();
  const offset = agora.getTimezoneOffset() * 60000; // offset do navegador em ms
  const dataLocal = new Date(agora.getTime() - offset);
  return dataLocal.toISOString().slice(0, 16);
}

export function formatarDataHora(dataHora) {
  if (!dataHora) return "";
  const data = new Date(dataHora);
  if (isNaN(data.getTime())) return "";

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0"); // Mês é base 0, então somamos 1.
  const ano = data.getFullYear();
  const horas = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");

  // 4. Monta e retorna a string no formato final.
  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}
export function getLocalDateTime(data, formato = "ISO") {
  const now = new Date(data);

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  if (formato === "BR") {
    return `${day}-${month}-${year}T${hours}:${minutes}:${seconds}`;
  }

  // Formato ISO: yyyy-MM-ddTHH:mm:ss
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export function formatarEnum(palavra) {
  if (!palavra || typeof palavra !== "string") {
    console.warn("⚠️ Valor inválido passado para formatarEnum:", palavra);
    return "";
  }
  return palavra
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/(^\w|\s\w)/g, (letra) => letra.toUpperCase());
}
export function limitarTexto(texto, maxChar) {
  //Limita o texto a um número máximo de caracteres(maxChar), caso o texto passe do máximo adiciona '...' no final
  if (texto.length > maxChar) {
    let newText = texto.slice(0, maxChar);
    newText += "...";
    return newText;
  }
  return texto;
}

export function formatarNomeUsuario(nomeUsuario) {
  //Recebe o nome completo e retorna apenas nome e sobrenome
  const nome = nomeUsuario.split(" ");

  return nome[0] + " " + nome[nome.length - 1];
}

export function formatarCPF(cpf) {
  const apenasNumeros = cpf.replace(/\D/g, "");

  return apenasNumeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function formatarCPFMascarado(cpf) {
  if (!cpf) return "";
  const cpfStr = String(cpf).trim();
  if (cpfStr.includes("*")) {
    return cpfStr;
  }
  let apenasNumeros = cpfStr.replace(/\D/g, "");
  if (apenasNumeros.length === 0) {
    return cpfStr;
  }
  if (apenasNumeros.length < 11) {
    apenasNumeros = apenasNumeros.padStart(11, "0");
  }
  if (apenasNumeros.length !== 11) {
    return cpfStr;
  }
  const parte1 = apenasNumeros.slice(0, 3);
  const parte2 = apenasNumeros.slice(9, 11);
  return `${parte1}.***.***-${parte2}`;
}

export function formatarParaInputDateTimeLocal(dataStr) {
  if (!dataStr) return "";
  const date = new Date(dataStr);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function sanitizarSql(texto) {
  if (!texto || typeof texto !== "string") return "";
  // Remove caracteres potencialmente perigosos para SQL Injection (ex: ', ", \, ;, --, /*, */)
  return texto.replace(/['"\\;]|\-\-|\/\*|\*\//g, "");
}
